import React, { useEffect, useState } from 'react';
import { Iconsvg } from '../../icon/icon';
import { Button, Form, Input, Modal } from 'antd';
import {
  getRedemptionShopCode,
  getRedemptionShopCodeVerify,
} from '../../servies/redemption';
import useDialogAlert from '../../hooks/useDialogAlert';
import moment from 'moment';

type Props = {};
const CouponCodeComponent = (props: Props) => {
  const { success, error } = useDialogAlert();
  const [isModalOpen, setIsModalOpen] = useState(false);

  // const [codeShop, setCodeShop] = useState<string>();
  const [form] = Form.useForm();
  const [redemptionShopCode, setRedemptionShopCode] = useState<{
    availableAt: string[];
    code: string;
    createdAt: string;
    id: string;
    shortDesc: string;
    status: string;
    usableSince: string;
    usableUntil: string;
    usedDate: string | null;
  }>();
  useEffect(() => {
    console.log('redemptionShopCode', redemptionShopCode);
  }, [redemptionShopCode]);
  const onReset = () => {
    form.resetFields();
  };
  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const onFinish = async (values: any) => {
    onReset();
    // setCodeShop(values.code);
    let res = await getRedemptionShopCode(values.code);
    if (res.status === 200) {
      // success({header:})
      setRedemptionShopCode(JSON.parse(res.data));

      showModal();
    } else {
      error({ header: 'ไม่พบข้อมูลรหัสคูปองนี้', sub: 'กรุณาตรวจสอบอีกครั้ง' });
    }
    console.log('Success:', res);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: window.innerWidth <= 426 ? '100px' : '40px',
      }}
    >
      <div className="header-component">รหัสคูปอง</div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          gap: '40px',
        }}
      >
        <div>
          <Iconsvg.IconCouponCode />
        </div>
        <div
          style={{
            color: '#2AC4CF',
            fontWeight: 600,
            fontSize: window.innerWidth <= 426 ? '28px' : '40px',
          }}
        >
          กรอกรหัสคูปอง
        </div>

        <Form
          name="basic"
          form={form}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          size="large"
          style={{ width: window.innerWidth >= 760 ? '40%' : '100%' }}
          // layout="vertical"
          // {...layout}
          // autoComplete="off"
        >
          <Form.Item
            name="code"
            rules={[{ required: true, message: 'Please input your code!' }]}
          >
            <Input className="input-coupon" style={{ textAlign: 'center' }} />
          </Form.Item>
          <Form.Item>
            <div
              style={{
                width: '100%',
                display: 'flex',
                gap: '10px',
                justifyContent: 'center',
              }}
            >
              <Button className="button-cancel-coupon">ยกเลิก</Button>
              <Button className="button-confirm-coupon" htmlType="submit">
                ยืนยัน
              </Button>
            </div>
          </Form.Item>
        </Form>
        <Modal
          title="ข้อมูลคูปอง"
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          className="modal-code"
          centered
          width={450}
          footer={
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  width: '100%',
                  height: '100%',
                }}
              >
                <Button
                  className="button-login-off"
                  style={{ height: '40px', width: '120px' }}
                  onClick={() => handleCancel()}
                >
                  ปิด
                </Button>
                <Button
                  className="button-login-submit-code"
                  style={{ height: '40px', width: '120px' }}
                  onClick={async () => {
                    handleCancel();
                    let modal = Modal.success({
                      centered: true,
                      className: 'modal-alert',
                      icon: <></>,
                      content: (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '20px',
                          }}
                        >
                          <div
                            style={{
                              color: '#2AC4CF',
                              fontWeight: 600,
                              fontSize: '18px',
                              lineHeight: '22px',
                            }}
                          >
                            ยืนยันการใช้คูปอง
                          </div>
                          <div className="modal-alert-text-sub-success">
                            ท่านต้องการใช้คูปองนี้ใช่หรือไม่ ?
                          </div>
                          <div style={{ display: 'flex' }}>
                            <div
                              style={{
                                color: '#3C3C3B',
                                fontWeight: 500,
                                fontSize: '18px',
                                lineHeight: ' 22px',
                                flex: 1,
                              }}
                            >
                              รหัสคูปอง :
                            </div>
                            <div style={{ flex: 1 }}>
                              {redemptionShopCode?.code}
                            </div>
                          </div>
                        </div>
                      ),
                      closable: false,
                      footer: (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '10px',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              gap: '10px',
                              width: '50%',
                              height: '100%',
                            }}
                          >
                            <Button
                              className="button-login-off"
                              onClick={() => modal.destroy()}
                            >
                              ยกเลิก
                            </Button>
                            <Button
                              className="button-login-submit-code"
                              onClick={async () => {
                                if (redemptionShopCode) {
                                  //   success({
                                  //     header: 'ทำรายการสำเร็จ',
                                  //     sub: '',
                                  //   });
                                  let res = await getRedemptionShopCodeVerify(
                                    redemptionShopCode.code
                                  );
                                  console.log('res', res);

                                  if (res.status === 201) {
                                    success({
                                      header: 'ทำรายการสำเร็จ',
                                      sub: '',
                                    });
                                  } else {
                                    error({
                                      header:
                                        res.message ===
                                        'Request failed with status code 400'
                                          ? 'รหัสคูปองนี้ถูกใช้งานไปแล้ว'
                                          : 'รหัสคูปองนี้หมดอายุแล้ว',
                                      sub: '',
                                    });
                                  }
                                  console.log('res', res);

                                  modal.destroy();
                                }
                              }}
                            >
                              ตกลง
                            </Button>
                          </div>
                        </div>
                      ),
                    });
                  }}
                >
                  ใช้คูปอง
                </Button>
              </div>
            </div>
          }
        >
          <div
            style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}
          >
            {' '}
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <div
                style={{
                  flex: 1,
                  fontSize: '18px',
                  color: '#3C3C3B',
                  fontWeight: 500,
                }}
              >
                รายละเอียด :
              </div>
              <div
                style={{
                  flex: 1,
                  fontSize: '18px',
                  color: '#3C3C3B',
                  fontWeight: 400,
                }}
              >
                {redemptionShopCode?.shortDesc}
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <div
                style={{
                  flex: 1,
                  fontSize: '18px',
                  color: '#3C3C3B',
                  fontWeight: 500,
                }}
              >
                รหัสคูปอง :
              </div>
              <div
                style={{
                  flex: 1,
                  fontSize: '18px',
                  color: '#3C3C3B',
                  fontWeight: 400,
                }}
              >
                {redemptionShopCode?.code}
              </div>
            </div>{' '}
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <div
                style={{
                  flex: 1,
                  fontSize: '18px',
                  color: '#3C3C3B',
                  fontWeight: 500,
                }}
              >
                ใช้งานได้ตั้งแต่ :
              </div>
              <div
                style={{
                  flex: 1,
                  fontSize: '18px',
                  color: '#3C3C3B',
                  fontWeight: 400,
                }}
              >
                {moment(redemptionShopCode?.usableSince).format('DD/MM/YYYY')}
              </div>
            </div>{' '}
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <div
                style={{
                  flex: 1,
                  fontSize: '18px',
                  color: '#3C3C3B',
                  fontWeight: 500,
                }}
              >
                วันหมดอายุ :
              </div>
              <div
                style={{
                  flex: 1,
                  fontSize: '18px',
                  color: '#3C3C3B',
                  fontWeight: 400,
                }}
              >
                {moment(redemptionShopCode?.usableUntil).format('DD/MM/YYYY')}
              </div>
            </div>{' '}
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <div
                style={{
                  flex: 1,
                  fontSize: '18px',
                  color: '#3C3C3B',
                  fontWeight: 500,
                }}
              >
                สาขาที่ร่วมรายการ :
              </div>
              <div
                style={{
                  flex: 1,
                  fontSize: '18px',
                  color: '#3C3C3B',
                  fontWeight: 400,
                }}
              >
                {redemptionShopCode?.availableAt.map((e) => (
                  <>{e}</>
                ))}
              </div>
            </div>{' '}
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <div
                style={{
                  flex: 1,
                  fontSize: '18px',
                  color: '#3C3C3B',
                  fontWeight: 500,
                }}
              >
                สถานะ :
              </div>
              <div
                style={{
                  flex: 1,
                  color: '#5CB631',
                  fontSize: '18px',
                  fontWeight: 400,
                }}
              >
                {redemptionShopCode?.status === 'available'
                  ? 'ใช้งานได้'
                  : 'ใช้ไปแล้ว'}
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default CouponCodeComponent;
